<template>
  <div @click="temporarilyDisablePostnlSync">
    <button v-if="!blockDate" class="btn border ml-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
      </svg>

      Temporarily disable PostNL sync
    </button>
    <button v-else class="btn border ml-2 TAILWIND">
      <div class="text-yellow-600 font-bold">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>

        PostNL sync blocked until {{ blockFormattedDate }}.
      </div>
    </button>
  </div>
</template>

<script>

import postNlBlockSync from "@/mixins/postnl-block-sync"

export default {
  mixins: [postNlBlockSync],
  methods: {
    temporarilyDisablePostnlSync() {
      this.$pushModal({
        modal: "TemporarilyBlockPostNL",
        toBind: {
          callback: () => {
            console.log("TemporarilyDisaglePostNLButton")
            this.loadCurrentBlock()
          }
        },
      })
    },
  },
}

</script>

<style scoped>

.btn {
  background-color: white !important;
  border-radius: 2px;
}

</style>
